import styles from "./navigation.module.scss";
import { useLocation, Link, href } from "react-router-dom";
import { routes } from "./routes";
import clsx from "clsx";

const Navigation = () => {
  const pathname = useLocation().pathname;
  return (
    <nav className={styles.navigation__wrap}>
      <div className={styles.navigation}>
        {routes.map((item) => (
          <Link to={item.href} key={item.name} className={styles.nav__item}>
            <img
              src={item.href === pathname ? item.active_image : item.image}
              alt={item.name}
              className={styles.nav__image}
            />
            <p
              className={clsx(
                styles.nav__name,
                pathname === item.href && styles.active
              )}
            >
              {item.name}
            </p>
          </Link>
        ))}
      </div>
    </nav>
  );
};
export default Navigation;
